import { Skeleton } from "antd";
export const SkeletonLoader = () => {
  return (
    <div>
      <Skeleton
        active
        title={false}
        height="6vh"
        style={{
          marginBottom: "3rem",
          marginTop: "2rem",
          padding: "0.8rem",
        }}
        paragraph={{ rows: 4 }}
        className="mb-7"
      />
      <Skeleton
        active
        title={false}
        height="6vh"
        style={{
          marginBottom: "3rem",
          padding: "0.8rem",
        }}
        paragraph={{ rows: 4 }}
      />
      <Skeleton
        active
        title={false}
        height="6vh"
        style={{
          marginBottom: "3rem",
          padding: "0.8rem",
        }}
        paragraph={{ rows: 4 }}
      />
    </div>
  );
};
